import { Component, OnInit, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

import { SnackBarData } from "digital-core";

@Component({
  selector: "snack-bar-body",
  templateUrl: "./snack-bar-body.component.html",
  styleUrls: ["./snack-bar-body.component.css"]
})
export class SnackBarBodyComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData,
    private snackBarRef: MatSnackBarRef<SnackBarBodyComponent>
  ) {
    // console.log("inside comp");
    // console.log(data);
  }

  ngOnInit() {}
  dismiss() {
    let c = 0;
    this.snackBarRef.dismiss();

  } 
}
